module.exports = __webpack_public_path__ + "img/clicx.607ec59d.png";